export default {
  col: (size = 1) => `${(100 / 24) * size}vw`,
  colors: {
    blue: '#212457',
    cyan: '#7CF8FA',
    red: '#EE0202',
    green: '#4CAF50',
  },
  gradients: {
    blue: {
      start: '#212457',
      end: '#212343',
    },
  },
}



// WEBPACK FOOTER //
// ./src/layouts/theme.js